import axios from 'axios';
import { auth } from './firebase';

export const api = axios.create({
  // Using || (not ??) so an empty string in .env also falls back. Vite reads
  // `VITE_API_BASE_URL=` as "", which is defined but falsy; `??` would leave
  // baseURL as "" and every request would hit the site origin (and fall
  // through Firebase Hosting's SPA rewrite, returning index.html as HTML).
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 60000,
});

/**
 * Attach the current Firebase ID token to every request. The token is a short-
 * lived JWT (1 hr); Firebase SDK transparently refreshes it, and getIdToken()
 * returns the current cached value with an optional forceRefresh.
 *
 * Backend verifies with firebase-admin.auth().verifyIdToken(token) and sets
 * req.user.sub = uid for downstream middleware.
 */
api.interceptors.request.use(async (cfg) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken(/* forceRefresh */ false);
    cfg.headers.set?.('Authorization', `Bearer ${token}`);
  }
  return cfg;
});
